// Version : 1.0.0
// Author : AGALYA
import BasicDetailsActionType from './bank-details.types';

/** ***************** BANK DETAILS CREATE START *********************** */
export const bankCreateStart = (bankCredentils: any) => ({
	type: BasicDetailsActionType.BANK_DETAILS_CREATE_START,
	payload: bankCredentils,
});

export const bankCreateSuccess = (bank: any) => ({
	type: BasicDetailsActionType.BANK_DETAILS_CREATE_SUCCESS,
	payload: bank,
});

export const bankCreateFailure = (error: unknown) => ({
	type: BasicDetailsActionType.BANK_DETAILS_CREATE_FAILURE,
	payload: error,
});

export const bankResponseChanged = () => ({
	type: BasicDetailsActionType.BANK_DETAILS_CREATE_RESPONSE_CHANGED,
});

export const bankResponseReset = () => ({
	type: BasicDetailsActionType.BANK_DETAILS_CREATE_RESPONSE_REST_START,
});
/** ***************** BANK DETAILS CREATE END *********************** */

/** ***************** BANK IFSC CODE RESPONSE START *********************** */
export const bankIFSCcodeStart = (IFSCcredentails: any) => ({
	type: BasicDetailsActionType.BANK_IFSC_CODE_RESPONSE_START,
	payload: IFSCcredentails,
});

export const bankIFSCcodeSuccess = (IFSC: any) => ({
	type: BasicDetailsActionType.BANK_IFSC_CODE_RESPONSE_SUCCESS,
	payload: IFSC,
});

export const bankIFSCcodeFailure = (IFSC: unknown) => ({
	type: BasicDetailsActionType.BANK_IFSC_CODE_RESPONSE_FAILURE,
	payload: IFSC,
});

export const bankIFSCcodeChanged = () => ({
	type: BasicDetailsActionType.BANK_IFSC_CODE_RESPONSE_CHANGED,
});

export const bankIFSCcodeReset = () => ({
	type: BasicDetailsActionType.BANK_IFSC_CODE_RESPONSE_RESET,
});
/** ***************** BANK IFSC CODE RESPONSE END *********************** */
